import type { Dispatch, SetStateAction } from 'react';
import { PlansTabBillingOptionsValues } from './components/plans-tab/types';

export enum SerializedBillingCycle {
  Monthly = 'month',
  Annual = 'year',
}

export interface SerializedPlanPrice {
  billingCycle: SerializedBillingCycle;
  amountCents: number;
}

export interface SerializedPlan {
  id: string;
  name: string;
  isActive: boolean;
  isMostPopular: boolean;
  callForPricingEnabled: boolean;
  prices: SerializedPlanPrice[];
  sortOrder: number;
  platformSlaId: string | null;
}

export interface SerializedPlansConfig {
  billingOptions: PlansTabBillingOptionsValues;
  plans: SerializedPlan[];
}
export enum TabValues {
  Plans = 0,
  Style = 1,
}

export enum LandingPageTabValues {
  Content = 0,
  Design = 1,
  Settings = 2,
}

export type ConfigSurface = 'memberships' | 'landingPage' | 'termsOfService' | 'privacyPolicy';

export interface ConfigFormSubmitState {
  isValid: boolean;
  isValidating: boolean;
  isSubmitting: boolean;
}

export const EMPTY_CONFIG_FORM_SUBMIT_STATE: ConfigFormSubmitState = {
  isValid: false,
  isValidating: false,
  isSubmitting: false,
};

export type ConfigFormSaveRequest<TValues> = () => Promise<{
  values: TValues;
  reset: () => void;
} | null>;

export interface ConfigFormSaveSlots<TValues> {
  onSaveRequestChange: Dispatch<SetStateAction<ConfigFormSaveRequest<TValues> | null>>;
  onDirtyChange: (isDirty: boolean) => void;
  onSubmitStateChange: (state: ConfigFormSubmitState) => void;
}

export interface ConfigSurfaceController<TValues> {
  saveSlots: ConfigFormSaveSlots<TValues>;
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  isSaveDisabled: boolean;
  handleSave: () => Promise<void>;
}
